import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';

import {
  commonAuctionCreate,
  tokenGetMetadataPath,
  tokenGetMetadataManifest,
} from '../util/thunks';
import EtherScanLink from './EtherScanLink';

class CreateCommonAuctionForm extends React.Component {

  state = {
    formData: {
      tokenURI: '',
      playerId: '',
    }
  }

  componentWillMount() {
    this.props.tokenGetMetadataPath().then(path => {
      this.props.tokenGetMetadataManifest(path);
    });
  }

  render() {
    return (
      <form autoComplete="off" onSubmit={this._handleSubmit}>

        <FormGroup controlId="playerId">
          <ControlLabel>Player Id</ControlLabel>
          <FormControl
            type="text"
            placeholder="Player Id"
            value={this.state.formData.playerId}
            onChange={this._handlePlayerIdChange}
          />
        </FormGroup>

        <FormGroup controlId="tokenURI">
          <ControlLabel>Token URI</ControlLabel>
          <FormControl
            disabled
            type="text"
            placeholder="Token URI"
            value={this.state.formData.tokenURI}
          />
        </FormGroup>

        <ListGroup>
          {this.props.data.error &&
            <ListGroupItem bsStyle="danger">{this.props.data.error}</ListGroupItem>
          }
          {this.props.data.success &&
            <ListGroupItem bsStyle="success">Transaction Posted! <EtherScanLink tx={this.props.data.tx} /></ListGroupItem>
          }
        </ListGroup>

        <Button type="submit">Submit</Button>
      </form>
    );
  }

  _handlePlayerIdChange = (e) => {

    let playerId = e.target.value;

    this.setState({
      formData: {
        ...this.state.formData,
        playerId,
        tokenURI: `ipfs://ipfs/${this.props.metadataManifest[playerId]}`,
      }
    });
  }

  _handleSubmit = (e) => {
    e.preventDefault();
    this.props.commonAuctionCreate(this.state.formData);
  }

}

const mapStateToProps = (state) => {
  return {
    data: state.createCommonAuctionForm,
    metadataManifest: state.tokenMetadata.manifest,
  };
};

const mapDispatchToProps = (dispatch) => ({

  tokenGetMetadataPath: () => {
    return dispatch(tokenGetMetadataPath());
  },

  tokenGetMetadataManifest: (path) => {
    return dispatch(tokenGetMetadataManifest(path));
  },

  commonAuctionCreate: ({ playerId, tokenURI }) => {
    return dispatch(commonAuctionCreate([playerId, tokenURI]));
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(CreateCommonAuctionForm);



// WEBPACK FOOTER //
// ./src/components/CreateCommonAuctionForm.js